import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Sidenav from '../../vendor/libs/sidenav'
import layoutHelpers from './helpers'
import logo_img from '../../assets/images/c.png'
import { Navbar, Nav, Dropdown } from 'react-bootstrap'

class LayoutSidenav extends Component {
  layoutSidenavClasses() {
    let bg = this.props.sidenavBg

    if (this.props.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
      bg = bg
        .replace(' sidenav-dark', '')
        .replace(' sidenav-light', '')
        .replace('-darker', '')
        .replace('-dark', '')
    }

    return `bg-${bg} ` + (
      this.props.orientation !== 'horizontal'
        ? 'layout-sidenav'
        : 'layout-sidenav-horizontal container-p-x flex-grow-0'
    )
  }

  toggleSidenav(e) {
    e.preventDefault()
    layoutHelpers.toggleCollapsed()
  }

  isMenuActive(url) {
    return this.props.location.pathname.indexOf(url) === 0
  }

  isMenuOpen(url) {
    return this.props.location.pathname.indexOf(url) === 0 && this.props.orientation !== 'horizontal'
  }

  render() {
    return (
      <Sidenav orientation={this.props.orientation} className={this.layoutSidenavClasses()}>

        {/* Brand demo (see src/demo.css) */}
        {this.props.orientation !== 'horizontal' && (
          <React.Fragment>
            <div className="app-brand demo">
              <span className="app-brand-logo demo">
                <img src={logo_img} alt="logo.png" style={{ height: '25px' }} />
              </span>
              <Link to="/pwa/scl/admin/home" className="app-brand-text demo sidenav-text font-weight-normal ml-2">MyCENTA</Link>
              <a href="#toggle" className="layout-sidenav-toggle sidenav-link text-large ml-auto" onClick={this.toggleSidenav}>
                <i className="ion ion-md-menu align-middle"></i>
              </a>
            </div>
            <Sidenav.Divider className="mt-0" />
          </React.Fragment>
        )}

        <div className={`sidenav-inner ${this.props.orientation !== 'horizontal' ? 'py-1' : ''}`}>
          {(!this.props.user || !this.props.user.accessToken) &&
            <Sidenav.RouterLink icon="fas fa-power-off" to="/pwa/signin">Sign in</Sidenav.RouterLink>}
          <Sidenav.RouterLink icon="fas fa-home" to="/pwa/scl/admin/home">Home</Sidenav.RouterLink>
          <Sidenav.RouterLink icon="fas fa-id-badge" to="/pwa/scl/org/admin/profile">School Profile</Sidenav.RouterLink>
          {/*<Sidenav.RouterLink icon="fas fa-certificate" to="/pwa/school_org_admin/walkin/allocation/walk_in_tq">Walk-in TQ Allocation</Sidenav.RouterLink>*/}
          <Sidenav.RouterLink icon="ion ion-md-document" to="/pwa/admin/post/home">My Posts</Sidenav.RouterLink>
          <Sidenav.RouterLink icon="oi oi-book" to="/pwa/scl/admin/vouchers">Vouchers</Sidenav.RouterLink>
          {/* <Sidenav.RouterLink icon="oi oi-book" to="/pwa/scl/admin/walkintq">WALK-IN TQ</Sidenav.RouterLink> */}
          {(this.props.user && this.props.user.accessToken) && <Sidenav.RouterLink icon="oi oi-list-rich" to="/pwa/scl/admin/purchases">List of Purchases</Sidenav.RouterLink>}
          {(this.props.user && this.props.user.accessToken) && <Sidenav.RouterLink icon="oi oi-list-rich" to="/pwa/scl/admin/vouchers/list">List of Vouchers</Sidenav.RouterLink>}
          {/*<Sidenav.RouterLink icon="fas fa-tasks" to="/pwa/allocations">List of Allocations</Sidenav.RouterLink>*/}
          {/*(this.props.user && this.props.user.accessToken) && <Sidenav.RouterLink icon="fas fa-tasks" to="/pwa/licenses">List of Licenses</Sidenav.RouterLink>*/}
          {(this.props.user && this.props.user.accessToken) && <Sidenav.RouterLink icon="fas fa-power-off" to="/pwa/logout">Logout</Sidenav.RouterLink>}
        </div>
      </Sidenav>
    )
  }
}

LayoutSidenav.propTypes = {
  orientation: PropTypes.oneOf(['vertical', 'horizontal'])
}

LayoutSidenav.defaultProps = {
  orientation: 'vertical'
}

export default connect(store => ({
  sidenavBg: store.theme.sidenavBg
}))(LayoutSidenav)
